const mutations = {
    calculateAnalyticalCommissionProfile(state, object) {
        const {
            profile,
            name,
            valorTotal,
            commissionTotal,
            volumeTotal,
            proposalsAmount,
            salesmanId,
            supervisorId,
            administratorId,
            chargeback,
            chargebackProposals,
            proposalId
        } = object

        let item = {
            profile,
            name,
            valorTotal: parseFloat(valorTotal),
            commissionTotal: parseFloat(commissionTotal),
            volumeTotal: parseFloat(volumeTotal),
            proposalsAmount: proposalsAmount,
            salesmanId: salesmanId,
            supervisorId: supervisorId,
            administratorId: administratorId,
            chargeback: chargeback,
            chargebackProposals: chargebackProposals,
            proposalId: proposalId
        };

        const hasItem = state.items.find(_item => (
            _item.name == item.name &&
            _item.valorTotal == item.valorTotal &&
            _item.commissionTotal == item.commissionTotal &&
            _item.volumeTotal == volumeTotal &&
            _item.proposalId == proposalId
        ))
        if (hasItem === undefined) {
            state.items.push(item)
        }
    },
    put(state, object) {
        state.item = object;
    },
    putDetail(state, object){
        state.detail = object;
    }
};

export default mutations;